'use strict';
/* ── THE CLIENT HTML ESCAPER (window.esc) ─────────────────────────────────────────────────────────
 *
 * The one definition in the browser. Escapes all five HTML metacharacters, the single quote
 * included, so the result is safe inside a single- or double-quoted attribute as well as in text.
 * Page scripts call esc() and never write their own: a local copy that drops one character is how
 * an escaper becomes an XSS hole, which is why the per-edit guard reports any second definition.
 *
 * ── Why a file of its own, the way components/safe-url.js is one ──────────────────────────────
 * It lived in components/api-utils.js, which also carries fetch, session and Slack proxy plumbing.
 * Three check harnesses loaded that whole module only to get the real escaper, and a fourth gave up
 * and kept a hand-copied one — the exact duplicate the rule exists to prevent. Dependency-free and
 * alone, it can be loaded by anything that renders markup, a harness included, and it is in place
 * before every other script in the shell rather than partway down it.
 *
 * Deliberately a top-level function rather than an IIFE: esc() is called bare across the client,
 * and a classic script's top-level function declaration is that global.
 */
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
window.esc = esc;
